/**
 * @file z-index 变量
 */
/**
 * 元素层级
 */
export const ZIndex = {
    /**
     * 弹窗所在层级
     */
    Modal: 1000,
    /**
     * 浮窗所在层级
     */
    Popover: 1030,
    /**
     * 下拉菜单, 下拉选择 (如日期选择) 等
     */
    Dropdown: 1050,
    /**
     * 操作确认框、小对话框等
     */
    Prompt: 1060,
    /**
     * toast 所在层级
     */
    Toast: 1070,
    /**
     * tooltip 所在层级
     */
    Tooltip: 2000,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWkluZGV4LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL1pJbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUVIOztHQUVHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHO0lBQ3BCOztPQUVHO0lBQ0gsS0FBSyxFQUFFLElBQUk7SUFDWDs7T0FFRztJQUNILE9BQU8sRUFBRSxJQUFJO0lBQ2I7O09BRUc7SUFDSCxRQUFRLEVBQUUsSUFBSTtJQUNkOztPQUVHO0lBQ0gsTUFBTSxFQUFFLElBQUk7SUFDWjs7T0FFRztJQUNILEtBQUssRUFBRSxJQUFJO0lBQ1g7O09BRUc7SUFDSCxPQUFPLEVBQUUsSUFBSTtDQUNMLENBQUEifQ==